module.exports = __webpack_public_path__ + "img/send-success.977c9980.svg";